import React from 'react';
import RankItem from './rank-item';
import {LeaderboardItemType} from '../../types';

interface RankListProps {
  data?: LeaderboardItemType[];
  loading?: boolean;
}

export default function RankList({data = [], loading = false}: RankListProps) {
  if (loading) {
    return (
      <div className="relative z-10">
        <div className="flex flex-col gap-2">
          {[...Array(10)].map((_, index) => (
            <div
              key={index}
              className="h-16 bg-gold-text/10 animate-pulse rounded-lg"
            />
          ))}
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="relative z-10 flex items-center justify-center h-32">
        <span className="text-gold-text/60">No Data</span>
      </div>
    );
  }

  return (
    <div className="relative z-10">
      <div className="flex flex-col gap-2">
        {data.map(user => (
          <RankItem
            key={user.id}
            rank={user.rank!}
            avatar={user.avatar}
            nickname={user.username || '---'}
            bonusScore={user.point}
            rewardAmount={user.bonus}
          />
        ))}
      </div>
    </div>
  );
}
